import { render, staticRenderFns } from "./AIWork.vue?vue&type=template&id=24f86169&scoped=true"
import script from "./AIWork.vue?vue&type=script&lang=js"
export * from "./AIWork.vue?vue&type=script&lang=js"
import style0 from "./AIWork.vue?vue&type=style&index=0&id=24f86169&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f86169",
  null
  
)

export default component.exports